__turbopack_context__.v({
  "icon": "HowToPlay-module__X_QxNG__icon",
  "list": "HowToPlay-module__X_QxNG__list",
  "text": "HowToPlay-module__X_QxNG__text",
});
